<template>
  <div>
    <form>
      <b-row class="toolbar-ptc mb-3">
        <b-col>
          <router-link :to="{ name: 'survey_list' }">
            <button 
              class="btn btn-ptc1"
              @mouseup="showReturnModal($event)" 
              @click.prevent 
              @keydown.enter.prevent
            >
              返回
            </button>
          </router-link>
        </b-col>
        <b-col class="text-center title">行銷活動 / 滿意度調查管理 / 新增問卷</b-col>
        <b-col class="text-right">
          <button type="button" class="btn btn-save" @click="save">儲存</button>
          <button type="button" class="btn btn-clear" @click="clear">清除</button>
        </b-col>
      </b-row>

      <b-card class="bg-default-card p-3 mb-3">
        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 標題
          </label>
          <input type="text" :class="['form-control', { 'is-invalid': valid_survey_name }]" v-model.trim="survey_name"
            :maxlength="survey_name_max" placeholder="請輸入問卷標題" @input="valid_survey_name = ''">
          <div class="text-danger" v-if="valid_survey_name">{{ valid_survey_name }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 引言
          </label>
          <textarea :class="['form-control', { 'is-invalid': valid_introduction }]" v-model.trim="introduction"
            :maxlength="introduction_max" rows="6" placeholder="請輸入問卷引言 (300字以內)"
            @input="valid_introduction = ''"></textarea>
          <div class="text-danger" v-if="valid_introduction">{{ valid_introduction }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 取餐時間_開始時間
          </label>
          <div class="d-flex align-items-center">
            <input type="date" :class="['form-control me-2 w-auto', { 'is-invalid': valid_sDateTime }]"
              style="width: 300px;" v-model="sdate" max="9999-12-31" @change="checkSDateTime">
            <input type="time" :class="['form-control me-2 w-auto', { 'is-invalid': valid_sDateTime }]"
              style="width: 300px;" v-model="sTime" @change="checkSDateTime">
          </div>
          <div class="text-danger" v-if="valid_sDateTime">{{ valid_sDateTime }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 取餐時間_結束時間
          </label>
          <div class="d-flex align-items-center">
            <input type="date" :class="['form-control me-2 w-auto', { 'is-invalid': valid_eDateTime }]"
              style="width: 300px;" v-model="edate" :min="sdate ? sdate : today" max="9999-12-31"
              @change="checkEDateTime">
            <input type="time" :class="['form-control me-2 w-auto', { 'is-invalid': valid_eDateTime }]"
              style="width: 300px;" v-model="eTime" :min="eTimeMin" @change="checkEDateTime">
          </div>
          <div class="text-danger" v-if="valid_eDateTime">{{ valid_eDateTime }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 會員等級
          </label>
          <select :class="['form-control', { 'is-invalid': valid_order_member_grade }]"
            v-model.number="order_member_grade">
            <option :value="1" :disabled="gift_type === 'coupon'">
              全會員 (僅能贈點) <span v-if="gift_type === 'coupon'">(贈券不可選)</span>
            </option>
            <option :value="2">僅限正式會員</option>
            <option :value="3" :disabled="gift_type === 'coupon'">
              僅限基本會員 (僅能贈點) <span v-if="gift_type === 'coupon'">(贈券不可選)</span>
            </option>
          </select>
          <div class="text-danger" v-if="valid_order_member_grade">{{ valid_order_member_grade }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 問卷禮的獎勵方式
          </label>
          <select :class="['form-control', { 'is-invalid': valid_gift_bonus || gift_certificate_code }]"
            v-model="gift_type">
            <option value="">請選擇</option>
            <option value="point">贈點</option>
            <option value="coupon" v-if="order_member_grade == 2">贈券</option>
          </select>
          <div class="text-muted small">※ 獎勵方式於建立問卷後，將<strong>不提供</strong>修改。</div>
          <div class="mt-2" v-if="gift_type === 'point'">
            <label class="control-label">
              <span class="text-danger">*</span> 點數
            </label>
            <input type="number" :class="['form-control', { 'is-invalid': valid_gift_bonus }]"
              v-model.number="gift_bonus" placeholder="輸入點數數字" @change="valid_gift_bonus = ''">
            <div class="text-danger" v-if="valid_gift_bonus">{{ valid_gift_bonus }}</div>
          </div>

          <div class="mt-2" v-if="gift_type === 'coupon'">
            <label class="control-label">
              <span class="text-danger">*</span> 券號ID
            </label>
            <input type="text" :class="['form-control', { 'is-invalid': valid_gift_certificate_code }]"
              v-model="gift_certificate_code" placeholder="輸入券號ID，舉例：DCxxx、ECxxx、BCxxx、CSxxx"
              @change="valid_gift_certificate_code = ''">
            <div class="text-danger" v-if="valid_gift_certificate_code">{{ valid_gift_certificate_code }}</div>
          </div>
        </div>

        <!-- 人工贈禮日期: 僅限贈券 -->
        <div class="form-group" v-if="gift_type === 'coupon'">
          <label class="control-label">
            <span class="text-danger">*</span> 人工贈禮日期 (人工贈券時使用)
          </label>
          <div class="d-flex align-items-center">
            <input type="date" :class="['form-control', { 'is-invalid': valid_gDate }]" style="width: 200px;"
              v-model="gdate" :min="gdateMin" max="9999-12-31" @change="valid_gDate = ''">
          </div>
          <div class="text-muted small">※ 獎勵方式為「贈券」時，此項為「必填」。</div>
          <div class="text-danger" v-if="valid_gDate">{{ valid_gDate }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 取餐方式
          </label>
          <select :class="['form-control', { 'is-invalid': valid_take_type }]" v-model.number="take_type">
            <option :value="1">內用和外帶</option>
            <option :value="2">外帶</option>
            <option :value="3">內用</option>
          </select>
          <div class="text-danger" v-if="valid_take_type">{{ valid_take_type }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 限制單次發送
          </label>
          <b-form-radio-group v-model="has_submit_times" :options="submitTimesOptions" />
          <div class="text-danger" v-if="valid_has_submit_times">{{ valid_has_submit_times }}</div>
          <div class="text-muted small mb-2">※ 是=每位會員只能填此問卷一次。</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 消費品牌
          </label>
          <select class="form-control" v-model="order_brand_code" @change="brandChange">
            <option value="">全品牌</option>
            <option value="MWD">僅限 MWD</option>
            <option value="CM">僅限 CM</option>
            <option value="REAL">僅限 REAL</option>
          </select>
        </div>

        <div class="form-group">
          <label class="control-label">
            {{ order_brand_code === "" ? "全品牌" : order_brand_code }} 消費門市
          </label>
          <button type="button" class="btn btn-warning text-white" @click="showStoreModal">選擇門市</button>
          <div class="text-muted small mb-2 mt-1">※ 消費門市必須屬於品牌條件設定。若為「全品牌」，仍可設定限定門市。</div>
          <div v-if="order_store_codes.length">
            <div :class="['selected-store-text', { expanded: showAllSelectedStores }]">
              已選：{{order_store_codes.map(code => getStoreNameByCode(code)).join(', ')}}
            </div>

            <button type="button" class="btn btn-link p-0 mt-1" @click="showAllSelectedStores = !showAllSelectedStores">
              {{ showAllSelectedStores ? '收合' : '展開全部' }}
            </button>
          </div>

        </div>

        <div class="form-group">
          <label class="control-label">
            {{ order_brand_code === "" ? "全品牌" : order_brand_code }} 消費商品
          </label>
          <button type="button" class="btn btn-warning text-white" @click="showProductModal"
            :disabled="order_brand_code === ''">選擇商品</button>
          <div class="text-muted small mb-2 mt-1">※ 消費的單品或套餐必須屬於品牌條件設定。若為「全品牌」，就<strong>不提供</strong>設定限定某商品。</div>
          <div v-if="order_product_codes.length">
            <div :class="['selected-product-text', { expanded: showAllSelectedProducts }]">
              已選：{{order_product_codes.map(code => getProductNameByCode(code)).join(', ')}}
            </div>

            <button type="button" class="btn btn-link p-0 mt-1"
              @click="showAllSelectedProducts = !showAllSelectedProducts">
              {{ showAllSelectedProducts ? '收合' : '展開全部' }}
            </button>
          </div>
        </div>

        <b-modal ref="productModal" :title="`選擇消費商品（${order_brand_code}）`" @ok="confirmProductSelection" ok-title="確定"
          cancel-title="取消" size="xl">
          <b-container fluid>
            <b-row>
              <b-col cols="6">
                <b-row class="mb-3">
                  <b-col cols="12">
                    <select class="form-control" v-model="selectedProductType">
                      <option value="">所有分類</option>
                      <option value="products">基礎品項 (單品/群組)</option>
                      <option value="combos">套餐組合</option>
                    </select>
                  </b-col>
                </b-row>

                <div class="product-checkbox-list" style="max-height: 400px; overflow-y: auto;">
                  <div v-if="filteredProductsByBrandAndType.length > 0">
                    <b-form-checkbox :checked="isAllFilteredProductsSelected" @change="toggleSelectAllFilteredProducts"
                      class="mb-2">
                      <strong class="text-warning font-weight-bolder">全選/全不選當前清單</strong>
                    </b-form-checkbox>
                    <hr class="my-1">
                  </div>
                  <b-form-checkbox-group v-model="tempProductSelection" stacked>
                    <div v-if="filteredProductsByBrandAndType.length === 0" class="text-muted text-center py-4">
                      無商品資料或不符合篩選條件。
                    </div>
                    <b-form-checkbox v-for="product in filteredProductsByBrandAndType" :key="product.code"
                      :value="product.code">
                      {{ product.brand }}_{{ product.name }} ({{ product.code }}) [{{ product.type | productTypeLabel
                      }}]
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </div>
              </b-col>

              <b-col cols="6">
                <b-card class="selected-products-card">
                  <template #header>
                    <strong>已選商品 ({{ tempProductSelection.length }} 項)</strong>
                  </template>
                  <div class="selected-products-list">
                    <div v-for="productCode in tempProductSelection" :key="productCode"
                      class="selected-product-item d-flex justify-content-between align-items-center mb-1">
                      <span>{{ getProductNameByCode(productCode) }}</span>
                      <button type="button" class="btn btn-sm btn-outline-danger"
                        @click="removeProductFromTempSelection(productCode)">
                        <span class="fas fa-trash-alt" title="移除商品"></span>
                      </button>
                    </div>
                    <div v-if="tempProductSelection.length === 0" class="text-muted text-center py-3">
                      尚未選擇任何商品
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-modal>


        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 優先權設定(整數)
          </label>
          <input type="number" :class="['form-control', { 'is-invalid': valid_priority }]" v-model.number="priority"
            min="1" step="1" placeholder="請輸入優先權數字 (1 為最優先)" @blur="fixPriority" @input="valid_priority = ''"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) && (this.value.length > 0 || event.charCode !== 48)">
          <div class="text-muted small mb-2">※ 若優先權相同，就依照先建立的問卷優先。1=最優先。</div>
          <div class="text-danger" v-if="valid_priority">{{ valid_priority }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">
            <span class="text-danger">*</span> 隨機率設定 (0 ~ 1)
          </label>
          <input type="number" :class="['form-control', { 'is-invalid': valid_random_rate }]"
            v-model.number="random_rate" min="0" max="1" step="0.0000001" @blur="fixRandomRate"
            @input="valid_random_rate = ''"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 46 && this.value.indexOf('.') === -1)"
            placeholder="請輸入隨機率 (例如 0.1 或 1)">
          <div class="text-muted small mb-2">※ 隨機率必須大於 0 且小於等於 1。</div>
          <div class="text-danger" v-if="valid_random_rate">{{ valid_random_rate }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">總發送數量上限(整數)</label>
          <input type="number" :class="['form-control', { 'is-invalid': valid_send_amount }]"
            v-model.number="send_amount" min="0" placeholder="請輸入總發送數量上限數字 (0 為無上限)" @blur="fixSendAmount"
            @input="valid_send_amount = ''"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) && (this.value.length > 0 || event.charCode !== 48)">
          <div class="text-muted small mb-2">※ 到達上限就不再發送此問卷。0=無上限。</div>
          <div class="text-danger" v-if="valid_send_amount">{{ valid_send_amount }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">提交的數量上限(整數)</label>
          <input type="number" :class="['form-control', { 'is-invalid': valid_accept_submit_amount }]"
            v-model.number="accept_submit_amount" min="0" placeholder="請輸入提交的數量上限數字 (0 為無上限)"
            @blur="fixAcceptSubmitAmount" @input="valid_accept_submit_amount = ''"
            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) && (this.value.length > 0 || event.charCode !== 48)">
          <div class="text-muted small mb-2">※ 若問卷提交數量已到達上限，不管總發送數量上限的上限，都不再發送此問卷。0=無上限。</div>
          <div class="text-danger" v-if="valid_accept_submit_amount">{{ valid_accept_submit_amount }}</div>
        </div>

        <div class="form-group">
          <label class="control-label">備註</label>
          <input type="text" class="form-control" v-model.trim="memo" maxlength="100" placeholder="請輸入備註">
        </div>

      </b-card>

      <b-card class="bg-default-card mt-3 p-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="mb-0">
            <span class="text-danger">*</span> 問卷題目
            <small class="text-muted">(至少需新增一題)</small>
          </label>
          <div class="text-danger" v-if="valid_questions">{{ valid_questions }}</div>
          <button type="button" class="btn btn-warning text-white" @click="addQuestion">
            <i class="fas fa-plus"></i> 新增題目
          </button>
        </div>

        <div v-for="(question, qIndex) in questions" :key="qIndex" class="border p-2 mb-2">
          <div class="d-flex justify-content-between align-items-center">
            <strong>題目 {{ qIndex + 1 }}</strong>
            <div>
              <button type="button" v-if="qIndex > 0" class="btn btn-outline-secondary btn_width btn_rounded"
                @click="moveQuestionUp(qIndex)" title="上移題目">
                <span class="fas fa-arrow-up"></span>
              </button>

              <button type="button" v-if="qIndex < questions.length - 1"
                class="btn btn-outline-secondary btn_width btn_rounded" @click="moveQuestionDown(qIndex)" title="下移題目">
                <span class="fas fa-arrow-down"></span>
              </button>

              <button type="button" class="btn btn-outline-danger btn_width btn_rounded"
                @click="removeQuestion(qIndex)">
                <span class="fas fa-trash-alt" title="刪除題目"></span>
              </button>
            </div>
          </div>

          <div class="form-group mt-2">
            <label>
              <span class="text-danger">*</span> 題目描述
            </label>
            <input type="text" :class="['form-control', { 'is-invalid': question.valid_question }]"
              v-model="question.question" placeholder="請輸入題目描述" @input="validateQuestionText(qIndex)">
            <!-- <div class="invalid-feedback" v-if="question.valid_question">
              {{ question.valid_question }}
            </div> -->
            <div class="text-danger" v-if="question.valid_question">{{ question.valid_question }}</div>
          </div>

          <div class="form-group">
            <label>
              <span class="text-danger">*</span> 問題呈現形式
            </label>
            <div class="text-danger" v-if="question.valid_q_type">{{ question.valid_q_type }}</div>
            <select class="form-control" v-model.number="question.question_type">
              <option value="1">文字</option>
            </select>
            <div class="text-muted small" v-if="!question.question_id">※ 新增題目後，將<strong>不提供</strong>修改。</div>
          </div>

          <div class="form-group">
            <label>
              <span class="text-danger">*</span> 答案形式
            </label>
            <div class="text-danger" v-if="question.valid_a_type">{{ question.valid_a_type }}</div>
            <select class="form-control" v-model.number="question.answer_type" @change="handleAnswerTypeChange(qIndex)">
              <option :value="1">單選自訂文字</option>
              <option :value="2">單選固定答案數字一到五 (1是非常滿意、5非常不滿意)</option>
              <option :value="3">多選自訂文字</option>
              <option :value="4">簡答300字限制</option>
            </select>
            <div class="text-muted small" v-if="!question.question_id">※ 新增題目後，將<strong>不提供</strong>修改。</div>
          </div>

          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" :id="'required-q-' + qIndex" v-model="question.is_required">
            <label class="form-check-label" :for="'required-q-' + qIndex">此題是否為必填</label>
          </div>

          <div v-if="question.answer_type === 1 || question.answer_type === 3">
            <label class="font-weight-bold">
              <span class="text-danger">*</span> 答案選項
              <small class="text-muted">(至少需一個選項)</small>
            </label>
            <div class="text-danger small mt-1" v-if="question.valid_answer">{{ question.valid_answer }}</div>
            <div v-for="(answer, aIndex) in question.answer_content" :key="aIndex"
              class="d-flex align-items-center mb-2">
              <input type="text" class="form-control" v-model="question.answer_content[aIndex]" placeholder="答案文字"
                @input="validateQuestionAnswers(qIndex)">
              <button type="button" class="btn btn-outline-danger btn_width btn_rounded"
                @click="removeAnswer(qIndex, aIndex)">
                <span class="fas fa-trash-alt" title="刪除答案"></span>
              </button>
            </div>

            <button type="button" class="btn btn-warning text-white" @click="addAnswer(qIndex)">
              <i class="fas fa-plus"></i> 新增答案
            </button>
          </div>

          <div v-else-if="question.answer_type === 2">
            <label>1是非常滿意、5非常不滿意</label>
          </div>

          <div v-else-if="question.answer_type === 4">
            <label>簡答題 (300字限制)</label>
          </div>
        </div>
      </b-card>

      <b-modal ref="storeModal" :title="`選擇消費門市（${order_brand_code === '' ? '全品牌' : order_brand_code}）`"
        @ok="confirmStoreSelection" ok-title="確定" cancel-title="取消" size="xl">
        <b-container fluid>
          <b-row>
            <b-col cols="6">
              <b-row class="mb-3">
                <b-col cols="6">
                  <select class="form-control" v-model="selectedCity" @change="filterDistricts">
                    <option value="" disabled>請選擇地區</option>
                    <option v-for="option in cityOptions.slice(1)" :value="option.value" :key="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </b-col>

                <b-col cols="6">
                  <select class="form-control" v-model="selectedDistrict">
                    <option value="" disabled>請選擇行政區</option>
                    <option v-for="option in districtOptions.slice(1)" :value="option.value" :key="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </b-col>
              </b-row>

              <div class="store-checkbox-list">
                <div v-if="selectedCity !== '' && selectedDistrict !== ''">
                  <b-form-checkbox :checked="isAllFilteredStoresSelected" @change="toggleSelectAllFilteredStores"
                    class="mb-2">
                    <strong class="text-warning font-weight-bolder">全選/全不選當前清單</strong>
                  </b-form-checkbox>

                  <b-form-checkbox-group v-model="tempStoreSelection" stacked>
                    <div v-for="cityGroup in filteredStoresByLocation" :key="cityGroup.City" class="mb-2">
                      <strong class="text-primary">{{ cityGroup.City }}</strong>

                      <div v-for="districtGroup in cityGroup.Districts" :key="districtGroup.District"
                        style="margin-left: 10px;">

                        <div v-for="store in districtGroup.Stores" :key="store.Code" style="margin-left: 10px;">
                          <b-form-checkbox :value="store.Code">
                            {{ store.BrandCode }}_{{ store.Name }} ({{ store.Code }})
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <div v-if="currentFilteredStoreCodes.length === 0" class="text-muted text-center py-4">
                      無門市資料，請檢查品牌或篩選條件。
                    </div>
                  </b-form-checkbox-group>
                </div>

                <div v-else class="text-muted text-center py-5">
                  請先選擇地區及行政區進行門市篩選
                </div>

              </div>
            </b-col>

            <b-col cols="6">
              <b-card class="selected-stores-card">
                <template #header>
                  <strong>已選 {{ order_brand_code === "" ? "全品牌" : order_brand_code }} 門市 ({{ tempStoreSelection.length
                  }} 間)</strong>
                </template>
                <div class="selected-stores-list">
                  <div v-for="storeCode in tempStoreSelection" :key="storeCode"
                    class="selected-store-item d-flex justify-content-between align-items-center">
                    <span>{{ getStoreNameByCode(storeCode) }}</span>
                    <button type="button" class="btn btn-sm btn-outline-danger"
                      @click="removeStoreFromTempSelection(storeCode)">
                      <span class="fas fa-trash-alt" title="移除門市"></span>
                    </button>
                  </div>
                  <div v-if="tempStoreSelection.length === 0" class="text-muted text-center py-3">
                    尚未選擇任何門市
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>

      <b-modal ref="mdCheck" hide-footer title="問卷新增">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定新增此則問卷?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm">確定</b-btn>
              <b-btn variant="secondary" @click="cancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

      <b-modal ref="mdCheckReturn" hide-footer title="返回提醒">
        <b-container fluid>
          <div class="row mb-3">
            <label class="control-label">確定要返回嗎？未儲存的新增問卷內容將會遺失。</label>
          </div>
          <div class="float-right">
            <b-btn variant="primary" @click="confirmReturn">確定</b-btn>
            <b-btn variant="secondary" @click="cancelReturn">取消</b-btn>
          </div>
        </b-container>
      </b-modal>

    </form>
  </div>
</template>

<script>

import axios from 'axios'
import { API_URL } from '@/store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'

export default {
  name: 'AddPage',
  data() {
    return {
      FunctionPermission: 0,
      /* 問卷資訊 */
      survey_name: '',
      survey_name_max: 32,
      valid_survey_name: '', // 驗證用
      introduction: '',
      introduction_max: 300,
      valid_introduction: '', // 驗證用
      sdate: '',
      sTime: '',
      valid_sDateTime: '', // 驗證用
      edate: '',
      eTime: '',
      valid_eDateTime: '', // 驗證用
      gdate: '',
      valid_gDate: '', // 驗證用
      order_member_grade: 1,
      valid_order_member_grade: '', // 驗證用
      gift_bonus: 0,
      valid_gift_bonus: '', // 驗證用
      gift_certificate_code: '',
      valid_gift_certificate_code: '', // 驗證用
      take_type: 1,
      valid_take_type: '', // 驗證用
      order_brand_code: '',
      order_store_codes: [],
      order_product_codes: [],
      questions: [],
      valid_questions: '', // 驗證用
      priority: 1,
      valid_priority: '', // 驗證用
      send_amount: 0,
      valid_send_amount: '', // 驗證用
      accept_submit_amount: 0,
      valid_accept_submit_amount: '', // 驗證用
      random_rate: 1,
      valid_random_rate: '', // 驗證用
      has_submit_times: true,
      valid_has_submit_times: '', // 驗證用
      memo: '',
      /* 問卷資訊 */

      /* 表單用資訊 */
      today: new Date().toISOString().substr(0, 10),
      stores: [], // 取得的門市清單
      showAllSelectedStores: false,
      showAllSelectedProducts: false,
      productsData: {
        products: [
          // type: 1, 2 items (單品 & 群組)
        ],
        combos: [
          // type: 4 items (套餐)
        ]
      },
      submitTimesOptions: [
        { text: '是', value: true },
        { text: '否', value: false }
      ],
      gift_type: '', // point: 贈點, coupon: 贈券
      tempStoreSelection: [],
      tempProductSelection: [],
      selectedProductType: '',
      selectedCity: '',
      selectedDistrict: '',
      cityOptions: [],
      districtOptions: []
      /* 表單用資訊 */
    }
  },
  created() {
    this.$parent.Loading = true;
    this.FunctionPermission = getFunctionPermission('F38') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'survey_list' })
      return
    }

    this.getAllStores()
    this.getAllProductsForSurvey()
  },

  filters: {
    productTypeLabel(type) {
      switch (type) {
        case 1:
          return '單品';
        case 2:
          return '群組';
        case 4:
          return '套餐';
        default:
          return '未知';
      }
    }
  },
  computed: {
    // 計算結束日期時間 (eTime)的最小值
    eTimeMin() {
      if (!this.stime) return '00:00';
      // stime作為基準來計算時間加法
      const [hours, minutes] = this.stime.split(':').map(Number);
      const date = new Date();
      date.setHours(hours, minutes + 1); // 增加一分鐘

      // 轉回 HH:mm 格式
      const h = String(date.getHours()).padStart(2, '0');
      const m = String(date.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    },
    // 計算 gdate 的最小值 (edate 的隔天)
    gdateMin() {
      if (!this.edate) return this.today;
      let d = new Date(this.edate);
      d.setDate(d.getDate() + 1);
      return d.toISOString().split('T')[0];
    },
    // ============================================= 門市設定
    allStores() {
      return this.stores.flatMap(city =>
        city.Districts.flatMap(d =>
          (d.Stores || []).map(store => ({
            ...store,
            City: city.City,
            District: d.District
          }))
        )
      )
    },
    filteredStoresByLocation() {
      let list = this.stores;

      // 1. 品牌過濾
      if (this.order_brand_code) {
        list = list.map(city => ({
          ...city,
          Districts: city.Districts.map(d => ({
            ...d,
            Stores: (d.Stores || []).filter(s => s.BrandCode === this.order_brand_code)
          })).filter(d => d.Stores.length)
        })).filter(city => city.Districts.length)
      }

      // 2. 城市過濾
      if (this.selectedCity) {
        list = list.filter(c => c.City === this.selectedCity)
      }

      // 3. 行政區過濾
      if (this.selectedDistrict) {
        list = list.map(city => ({
          ...city,
          Districts: city.Districts.filter(d => d.District === this.selectedDistrict)
        })).filter(city => city.Districts.length)
      }

      return list
    },
    // 取得當前篩選結果中的所有門市代碼 (用於全選)
    currentFilteredStoreCodes() {
      return this.filteredStoresByLocation.flatMap(city =>
        city.Districts.flatMap(d => (d.Stores || []).map(s => s.Code))
      )
    },
    // 判斷門市是否全選
    isAllFilteredStoresSelected() {
      const filteredCodes = this.currentFilteredStoreCodes
      if (filteredCodes.length === 0) return false

      // 檢查 filteredCodes 是否都是 tempStoreSelection 的子集
      return filteredCodes.every(code => this.tempStoreSelection.includes(code))
    },
    // ============================================= 門市設定

    // ============================================= 商品設定
    allProducts() {
      return [
        ...(this.productsData.products || []),
        ...(this.productsData.combos || [])
      ];
    },
    filteredProductsByBrandAndType() {
      // 如果是全品牌 (order_brand_code === '')，根據規則不能設定限定商品
      if (!this.order_brand_code) {
        return [];
      }

      let list = [];
      const brandCode = this.order_brand_code;
      const typeKey = this.selectedProductType;

      // 1. 根據 selectedProductType 決定使用 products 或 combos 列表
      if (typeKey === 'products' || typeKey === '') {
        // 如果選擇 'products' 或 '所有分類'，則包含 products 列表
        list.push(...(this.productsData.products || []));
      }
      if (typeKey === 'combos' || typeKey === '') {
        // 如果選擇 'combos' 或 '所有分類'，則包含 combos 列表
        list.push(...(this.productsData.combos || []));
      }

      // 2. 品牌過濾 (必須符合已選品牌)
      return list.filter(p => p.brand === brandCode);
    },
    isAllFilteredProductsSelected() {
      const filteredCodes = this.filteredProductsByBrandAndType.map(p => p.code); // 取得當前清單所有代碼
      if (filteredCodes.length === 0) return false;
      // 檢查所有篩選後的商品代碼是否都在 tempProductSelection 中
      return filteredCodes.every(code => this.tempProductSelection.includes(code));
    },
    // ============================================= 商品設定
  },
  watch: {
    order_member_grade() {
      // 當等級改變時，將獎勵方式重置為空字串（請選擇）
      this.gift_type = '';

      // 同時清空已輸入的點數或券號
      this.gift_bonus = null;
      this.gift_certificate_code = '';
      this.gdate = ''; // 清空人工贈禮日期

      // 清除相關的驗證錯誤訊息
      this.valid_gift_bonus = '';
      this.valid_gift_certificate_code = '';
      this.valid_gDate = ''
    }
  },
  methods: {
    /* 檢查設定值 */
    checkSDateTime() {
      if (this.sdate && this.sTime) {
        this.valid_sDateTime = '';
      }
    },
    checkEDateTime() {
      if (this.edate && this.eTime) {
        this.valid_eDateTime = '';
      }
    },
    fixPriority() {
      this.valid_priority = '';
      // 只有在有值的情況下才校正
      if (this.priority !== null && this.priority === '') {
        // 如果小於 1，強制回歸 1
        if (this.priority < 1) {
          this.priority = 1;
          return
        }
      }
    },
    fixSendAmount() {
      this.valid_send_amount = '';
      if (this.send_amount === null || this.send_amount === '') {
        this.send_amount = 0;
        return
      }
      // 只有在有值的情況下才校正
      if (this.send_amount !== null && this.send_amount < 0) {
        // 如果小於 0，強制就設定為預設值 0
        if (this.send_amount < 0) {
          this.send_amount = 0;
          return
        }
      }
    },
    fixAcceptSubmitAmount() {
      this.valid_accept_submit_amount = '';
      if (this.accept_submit_amount === null || this.accept_submit_amount === '') {
        this.accept_submit_amount = 0;
        return
      }
      // 只有在有值的情況下才校正
      if (this.accept_submit_amount !== null && this.accept_submit_amount < 0) {
        // 如果小於 0，強制就設定為預設值 1
        if (this.accept_submit_amount < 0) {
          this.accept_submit_amount = 0;
          return
        }
      }
    },
    fixRandomRate() {
      this.valid_random_rate = '';
      // 如果使用者把內容清空了，強制就設定為預設值 1
      if (this.random_rate === null || this.random_rate === '') {
        this.random_rate = 1;
        return
      }

      // 1. 檢查上限：不能大於 1
      if (this.random_rate > 1) {
        this.random_rate = 1;
        return
      }

      // 2. 檢查下限：不能小於或等於 0
      if (this.random_rate <= 0) {
        this.random_rate = 0.001; // 自動跳到你定義的最小正數
        return
      }
    },
    /* 檢查設定值 */

    handleAnswerTypeChange(qIndex) {
      const question = this.questions[qIndex];

      // 1. 清除該題相關的驗證報錯訊息
      question.valid_a_type = '';
      question.valid_answer = '';

      // 2. 根據切換後的類型，動態重置答案內容
      if (question.answer_type === 1 || question.answer_type === 3) {
        // 切換到「自訂文字」時，預設給予一個空白選項
        // 這樣使用者就不需要再點一次「新增答案」才有輸入框
        question.answer_content = [''];
      } else {
        // 切換到「固定數字 1-5」或「簡答」時
        // 清空 answer_content 陣列，確保不會送出多餘的舊資料
        question.answer_content = [];
      }

    },

    getProductNameByCode(code) {
      const product = this.allProducts.find(p => p.code === code);

      if (!product) return code;

      const typeLabel = this.$options.filters.productTypeLabel(product.type);

      let display = `${product.brand}_${product.name} (${product.code}) [${typeLabel}]`;

      return display;
    },
    removeProductFromTempSelection(code) {
      this.tempProductSelection = this.tempProductSelection.filter(c => c !== code);
    },
    toggleSelectAllFilteredProducts(checked) {
      const filteredCodes = this.filteredProductsByBrandAndType.map(p => p.code);
      if (checked) {
        // 全選：合併代碼 (確保不重複)
        this.tempProductSelection = Array.from(new Set([...this.tempProductSelection, ...filteredCodes]));
      } else {
        // 全不選：移除代碼
        this.tempProductSelection = this.tempProductSelection.filter(code => !filteredCodes.includes(code));
      }
    },

    // 商品 Modal
    async showProductModal() {
      if (this.order_brand_code === '') {
        miniToastr.warn('品牌為全品牌時，不能設定限定商品。', '操作限制');
        return;
      }

      this.$parent.Loading = true;
      try {
        await this.getAllProductsForSurvey();
        this.tempProductSelection = [...this.order_product_codes];
        this.selectedProductType = '';
        this.$refs.productModal.show();
      } catch (error) {
        console.error("Failed to load products before showing modal:", error);
        miniToastr.error('無法載入商品資料', '錯誤');
      } finally {
        this.$parent.Loading = false;
      }
    },
    confirmProductSelection() {
      this.order_product_codes = [...this.tempProductSelection];
      this.$refs.productModal.hide();
    },
    getAllProductsForSurvey() {
      const apiUrl = API_URL + "/web/marketing/surveys/products/list/v1";

      return axios
        .post(apiUrl, {
          brandCode: (this.order_brand_code === '') ? '' : this.order_brand_code
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false

          if (response.data.result === "0000" && response.data.data && response.data.data.length > 0) {

            // 取得第一個 (且通常是唯一一個) 品牌資料物件
            const brandData = response.data.data[0];
            const brandCode = brandData.brand_code;
            const details = brandData.brand_products_details;

            // 展開產品陣列，並為每個產品加上 'brand' 屬性

            // 1. 處理單品/群組 (products)
            const productsWithBrand = (details.products || []).map(p => ({
              ...p,
              brand: brandCode // 加上 brand 屬性
            }));

            // 2. 處理套餐 (combos)
            const combosWithBrand = (details.combos || []).map(p => ({
              ...p,
              brand: brandCode // 加上 brand 屬性
            }));

            // 3. 賦值為期望的結構
            this.productsData = {
              products: productsWithBrand,
              combos: combosWithBrand
            };

          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.$parent.Loading = false;
            miniToastr.error(response.data.message, "商品資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, "商品資料讀取異常或連線失敗");
          console.log(error);
        });
    },

    brandChange() {
      this.order_store_codes = [];
      this.order_product_codes = [];
      // 品牌變更後，重設門市選擇的篩選條件，並重新生成城市選單
      this.selectedCity = ''
      this.selectedDistrict = ''
      this.getAllStores()
      this.getAllProductsForSurvey()
    },

    getAllStores() {
      const apiUrl = API_URL + "/web/marketing/getallstores/v1";

      return axios
        .post(apiUrl, {
          status: 1,
          brandCode: (this.order_brand_code === '') ? '' : this.order_brand_code
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);

          if (response.data.result === "0000") {
            this.stores = response.data.data || []
            this.generateCityList()
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "門市資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          miniToastr.error(error, "門市資料讀取異常或連線失敗");
          console.log(error);
        });
    },

    // 題目
    addQuestion() {
      this.questions.push({
        question: '',         // 題目描述
        question_type: 1,     // 問題呈現形式
        answer_type: 1,       // 答案形式
        is_required: false,
        answer_content: [''], // 預設一個空答案
        // 驗證狀態變數
        valid_question: '',
        valid_q_type: '',
        valid_a_type: '',
        valid_answer: ''
      });
    },
    removeQuestion(qIndex) {
      this.questions.splice(qIndex, 1);
    },
    moveQuestionUp(qIndex) {
      if (qIndex === 0) return;
      const questions = this.questions;
      const temp = questions[qIndex - 1];
      this.$set(this.questions, qIndex - 1, questions[qIndex]);
      this.$set(this.questions, qIndex, temp);
    },
    moveQuestionDown(qIndex) {
      const questions = this.questions;
      if (qIndex === questions.length - 1) return;
      const temp = questions[qIndex + 1];
      this.$set(this.questions, qIndex + 1, questions[qIndex]);
      this.$set(this.questions, qIndex, temp);
    },

    // 驗證單一題目的題目描述
    validateQuestionText(qIndex) {
      const q = this.questions[qIndex];
      // 檢查是否為空字串
      if (!q.question || q.question.trim() === '') {
        q.valid_question = '請輸入題目描述'; // 賦值後會觸發 HTML 的 is-invalid
        return false;
      } else {
        q.valid_question = ''; // 清空錯誤訊息，紅框消失
        return true;
      }
    },

    // 驗證單一題目的答案選項是否合法
    validateQuestionAnswers(qIndex) {
      const q = this.questions[qIndex];

      // 初始化或清空錯誤訊息
      q.valid_answer = '';

      if (q.answer_type === 1 || q.answer_type === 3) {
        // 檢查是否有選項
        if (!q.answer_content || q.answer_content.length === 0) {
          q.valid_answer = '至少需新增一個答案選項';
          return false;
        }

        // 檢查是否有空選項
        const hasEmpty = q.answer_content.some(ans => !ans || !ans.trim());
        if (hasEmpty) {
          q.valid_answer = '答案選項內容不能為空';
          return false;
        }
      }
      return true;
    },

    // 加答案
    addAnswer(qIndex) {
      const q = this.questions[qIndex];
      if (q.answer_type === 1 || q.answer_type === 3) {
        if (!Array.isArray(q.answer_content)) {
          q.answer_content = [];
        }
        q.answer_content.push(''); // 新增空字串

        // 新增後即時檢查（此時通常會因為最後一個是空的而顯示警告）
        this.validateQuestionAnswers(qIndex);
      }
    },

    // 刪除答案
    removeAnswer(qIndex, aIndex) {
      const q = this.questions[qIndex];
      if (q.answer_type === 1 || q.answer_type === 3) {
        q.answer_content.splice(aIndex, 1);

        // 刪除後即時檢查
        this.validateQuestionAnswers(qIndex);
      }
    },

    // 門市 Modal
    showStoreModal() {
      this.tempStoreSelection = [...this.order_store_codes];
      this.selectedCity = '';
      this.selectedDistrict = '';
      // 由於 generateCityList 已在 getAllStores 中呼叫，這裡只需確保城市選項已載入
      if (this.cityOptions.length === 0) {
        this.generateCityList();
      }
      this.filterDistricts(); // 清空行政區選單
      this.$refs.storeModal.show();
    },

    generateCityList() {
      const cities = this.filteredStoresByLocation.map(c => c.City);
      const citiesSet = new Set(cities);

      // 重新生成選項，包含 '全部地區'
      this.cityOptions = [{ value: '', text: '全部地區' }].concat(
        Array.from(citiesSet).map(city => ({
          value: city,
          text: city
        }))
      );
    },

    filterDistricts() {
      this.selectedDistrict = '';
      this.districtOptions = [];

      const selectedCityGroup = this.filteredStoresByLocation.find(c => c.City === this.selectedCity);

      if (selectedCityGroup) {
        const districtsSet = new Set(selectedCityGroup.Districts.map(d => d.District));
        // 重新生成選項，包含 '全部行政區'
        this.districtOptions = [{ value: '', text: '全部行政區' }].concat(
          Array.from(districtsSet).map(district => ({
            value: district,
            text: district
          }))
        );
      } else {
        this.districtOptions = [{ value: '', text: '全部行政區' }];
      }
    },

    // 取得門市名稱 (代碼轉名稱)
    getStoreNameByCode(code) {
      const store = this.allStores.find(s => s.Code === code);
      return store ? `${store.BrandCode}_${store.Name} (${store.Code})` : code;
    },
    removeStoreFromTempSelection(code) {
      this.tempStoreSelection = this.tempStoreSelection.filter(c => c !== code);
    },
    toggleSelectAllFilteredStores(checked) {
      const filteredCodes = this.currentFilteredStoreCodes;
      if (checked) {
        // 全選：將當前篩選結果的門市加入 tempStoreSelection (Set 避免重複)
        this.tempStoreSelection = Array.from(new Set([...this.tempStoreSelection, ...filteredCodes]));
      } else {
        // 全不選：從 tempStoreSelection 中移除當前篩選結果的門市
        this.tempStoreSelection = this.tempStoreSelection.filter(code => !filteredCodes.includes(code));
      }
    },

    // 門市選擇確認
    confirmStoreSelection() {
      this.order_store_codes = [...this.tempStoreSelection];
      this.$refs.storeModal.hide();
    },

    save() {
      let hasError = false;
      /* 驗證欄位合法 */
      this.valid_survey_name = '';
      this.valid_introduction = '';
      this.valid_sDateTime = '';
      this.valid_eDateTime = '';
      this.valid_order_member_grade = '';
      this.valid_gift_bonus = '';
      this.valid_gift_certificate_code = '';
      this.valid_gDate = '';
      this.valid_priority = '';
      this.valid_random_rate = '';
      this.valid_take_type = '';
      this.valid_has_submit_times = '';
      this.valid_send_amount = '';
      this.valid_accept_submit_amount = '';
      this.valid_questions = '';

      // 標題
      if (!this.survey_name || this.survey_name.length === 0) {
        this.valid_survey_name = '請輸入問卷標題';
        hasError = true;
      }
      if (this.survey_name.length > this.survey_name_max) {
        this.valid_survey_name = '問卷標題長度不可超過 32 個字';
        hasError = true;
      }

      // 引用
      if (!this.introduction || this.introduction.length === 0) {
        this.valid_introduction = '請輸入問卷引言';
        hasError = true;
      }
      if (this.introduction.length > this.introduction_max) {
        this.valid_introduction = '問卷引言長度不可超過 300 個字';
        hasError = true;
      }

      // 建立各個時間點
      const startTake = new Date(`${this.sdate} ${this.sTime}`);
      const endTake = new Date(`${this.edate} ${this.eTime}`);
      const giftDate = new Date(`${this.gdate} 00:00:00`);

      // 取餐時間的日期與時間
      if (!this.sdate || !this.sTime) {
        this.valid_sDateTime = '請完整填寫取餐時間「開始」日期與時間';
        hasError = true;
      }
      if (!this.edate || !this.eTime) {
        this.valid_eDateTime = '請完整填寫取餐時間「結束」日期與時間';
        hasError = true;
      } else if (endTake <= startTake) {
        this.valid_eDateTime = '取餐時間「結束」日期與時間必須晚於取餐時間「開始」日期與時間';
        hasError = true;
      }

      // 會員等級
      if (!this.order_member_grade) {
        this.valid_order_member_grade = '請選擇會員等級';
        hasError = true;
      }

      // 問卷禮的獎勵方式
      if (this.gift_type === 'point' && this.gift_bonus <= 0) {
        this.valid_gift_bonus = '請設定「贈點」的點數';
        hasError = true;
      } else if (this.gift_type === 'coupon' && this.gift_certificate_code === '') {
        this.valid_gift_certificate_code = '請設定「贈券」的券號ID';
        hasError = true;
      }
      // 贈券: 人工贈禮日期檢查 (gdate >= edate)
      if (this.gift_type === 'coupon') {
        if (!this.gdate) {
          this.valid_gDate = '請選擇人工贈禮日期';
          hasError = true;
        } else if (giftDate <= endTake) {
          this.valid_gDate = '贈禮日期不能早於提交截止日期';
          hasError = true;
        }
      }

      // 優先權
      if (this.priority === null || this.priority === "") {
        this.valid_priority = '優先權不可為空';
        hasError = true;
      } else if (!Number.isInteger(this.priority)) {
        this.valid_priority = '優先權必須為整數';
        hasError = true;
      } else if (this.priority < 1) {
        this.valid_priority = '最小數字為 1';
        hasError = true;
      }

      // 總發送數量上限
      if (this.send_amount === null) {
        this.valid_send_amount = '總發送數量不可為空';
        hasError = true;
      } else if (!Number.isInteger(this.send_amount)) {
        this.valid_send_amount = '總發送數量必須為整數';
        hasError = true;
      } else if (this.send_amount < 0) {
        this.valid_send_amount = '最小數字為 0';
        hasError = true;
      }

      // 提交的數量上限
      if (this.accept_submit_amount === null) {
        this.valid_accept_submit_amount = '提交的數量上限不可為空';
        hasError = true;
      } else if (!Number.isInteger(this.accept_submit_amount)) {
        this.valid_accept_submit_amount = '提交的數量上限必須為整數';
        hasError = true;
      } else if (this.accept_submit_amount < 0) {
        this.valid_accept_submit_amount = '最小數字為 0';
        hasError = true;
      }

      // 隨機率
      if (!this.random_rate || this.random_rate <= 0 || this.random_rate > 1) {
        this.valid_random_rate = '隨機率必須介於 0(不含) 到 1 之間';
        hasError = true;
      }

      // 題目和答案
      if (!this.questions || this.questions.length === 0) {
        this.valid_questions = '尚未新增任何題目，請至少新增一題問卷題目';
        hasError = true;
      } else {
        this.valid_questions = '';
        this.questions.forEach((q, index) => {

          // 檢查題目描述
          if (!q.question || !q.question.trim()) {
            q.valid_question = '請輸入題目描述';
            hasError = true;
          } else {
            q.valid_question = ''; // 如果補填了，就清掉紅框
          }

          // 檢查呈現形式與答案形式 (必選)
          if (!q.question_type) hasError = true;
          if (!q.answer_type) hasError = true;

          // 檢查答案選項 (針對類型 1 和 3)
          if (q.answer_type === 1 || q.answer_type === 3) {
            if (!q.answer_content || q.answer_content.length === 0) {
              q.valid_answer = '至少需新增一個答案選項';
              hasError = true;
            } else if (q.answer_content.some(ans => !ans || !ans.trim())) {
              q.valid_answer = '答案選項內容不能為空';
              hasError = true;
            } else {
              q.valid_answer = '';
            }
          } else {
            q.valid_answer = ''; // 其他類型不檢查，清空錯誤
          }
        });
      }


      // 驗證失敗
      if (hasError) {
        console.log("攔截送出：資料有誤");
        return;
      }

      // 通過檢查，顯示 Modal
      this.$refs.mdCheck.show()
    },
    clear() {
      // 執行清除邏輯...
      // Modal 暫存
      this.tempStoreSelection = []
      this.tempProductSelection = []
      // 城市與行政區
      this.selectedCity = ''
      this.selectedDistrict = ''
      this.cityOptions = [] // 清空後會由 generateCityList 重新生成
      this.districtOptions = []

      // 重設所有表單欄位
      this.survey_name = '';
      this.introduction = '';
      this.sdate = '';
      this.edate = '';
      this.sTime = '';
      this.eTime = '';
      this.order_member_grade = 1;
      this.take_type = 1;
      this.order_brand_code = '';
      this.order_store_codes = [];
      this.order_product_codes = [];
      this.questions = [];
      this.priority = 1;
      this.send_amount = 0;
      this.accept_submit_amount = 0;
      this.has_submit_times = true;
      this.gift_type = '';
      this.gift_bonus = 0;
      this.gift_certificate_code = '';
      this.memo = '';

      // 清掉驗證的錯誤訊息
      this.valid_survey_name = '';
      this.valid_introduction = '';
      this.valid_sDateTime = '';
      this.valid_eDateTime = '';
      this.valid_order_member_grade = '';
      this.valid_gift_bonus = '';
      this.valid_gift_certificate_code = '';
      this.valid_gDate = '';
      this.valid_priority = '';
      this.valid_random_rate = '';
      this.valid_take_type = '';
      this.valid_has_submit_times = '';
      this.valid_send_amount = '';
      this.valid_accept_submit_amount = '';
      this.valid_questions = '';

      this.getAllStores(); // 重新載入門市資料並初始化選項
      this.getAllProductsForSurvey(); // 重新載入商品資料並初始化選項
    },
    confirm() {
      // 1. 隱藏 Modal 並顯示 Loading 狀態
      this.$refs.mdCheck.hide();
      this.$parent.Loading = true;

      // 2. 處理票券/點數邏輯，確保只有一個會被送出
      let giftCertificateCode = this.gift_certificate_code || '';
      let giftBonus = Number(this.gift_bonus) || 0;

      // 如果有輸入禮券代碼 → bonus 變 0
      if (giftCertificateCode !== '') {
        giftBonus = 0;
      }
      // 如果有輸入點數 → 禮券代碼變空字串
      if (giftBonus > 0) {
        giftCertificateCode = '';
      }

      // 3. 整理 questions 陣列
      let normalizedQuestions = this.questions.map((q, index) => {
        return {
          seq: index + 1, // 題號從 1 開始
          is_required: !!q.is_required,
          question: q.question || '',
          question_type: q.question_type,
          answer_type: q.answer_type,
          // 只有單選 (1) / 多選 (3) 才有 answer_content
          answer_content: (q.answer_type === 1 || q.answer_type === 3)
            ? (Array.isArray(q.answer_content)
              ? q.answer_content
                .map(a => a.trim())      // 去掉前後空白
                .filter(a => a !== '')   // 過濾空字串
              : [])
            : undefined
        };
      });

      // 4. 構造 Request Body 物件
      let requestBody = {
        name: this.survey_name,
        introduction: this.introduction,
        // 日期時間字串應加上空格 ' '，以符合 JSON 範例
        user_take_start_at: this.sdate + ' ' + this.sTime + ':00',
        user_take_end_at: this.edate + ' ' + this.eTime + ':00',

        // accept_submit_end_at: this.adate,
        gift_deliver_at: this.gdate,
        order_member_grade: this.order_member_grade,

        // 如果 order_store_codes 為空，則屬性不會被包含在 JSON 中
        order_store_codes: this.order_store_codes.length === 0 ? undefined : this.order_store_codes,
        // 如果 order_product_codes 為空，則屬性不會被包含在 JSON 中
        order_product_codes: this.order_product_codes.length === 0 ? undefined : this.order_product_codes,
        // 如果 order_brand_code 為空字串，則屬性不會被包含在 JSON 中
        order_brand_code: this.order_brand_code === '' ? undefined : this.order_brand_code,

        take_type: this.take_type,
        send_amount: this.send_amount,
        accept_submit_amount: this.accept_submit_amount,
        has_submit_times: this.has_submit_times,
        random_rate: this.random_rate,
        priority: this.priority,

        // 使用處理後的變數
        gift_certificate_code: giftCertificateCode,
        gift_bonus: giftBonus,

        memo: this.memo,

        // 直接傳送整理好的 questions 陣列
        questions: normalizedQuestions
      };

      this.createSurvey(requestBody);
    },

    createSurvey(data) {
      return axios.post(API_URL + '/web/marketing/surveys/v1',
        data
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('問卷已新增')
            this.$router.push({ name: 'survey_list', params: {} })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          console.log(error)
          if (error.response && error.response.status === 400) {
            const responseData = error.response.data || {};
            const message = responseData.message || '';
            const resultCode = responseData.result || '未知代碼';
            const errMsg = `請求格式錯誤，請檢查輸入欄位 ${message} (錯誤代碼:${resultCode})`;
            miniToastr.error(errMsg, '新增失敗')
            console.log('400 Bad Request:', error.response.data)
          } else {
            miniToastr.error(error.response.data.message || '伺服器錯誤', '新增失敗')
            console.log(error.response.data)
          }
        })
    },
    cancel() {
      this.$refs.mdCheck.hide()
    },
    showReturnModal(event) {
      // 只允許滑鼠左鍵點擊 (button 0)
      if (event.button !== 0) return;

      this.$refs.mdCheckReturn.show();
    },
    confirmReturn() {
      this.$refs.mdCheckReturn.hide();
      this.$router.push({ name: 'survey_list' });
    },
    cancelReturn() {
      this.$refs.mdCheckReturn.hide();
    }
  }
};
</script>

<style scoped>
.btn-ptc1 {
  margin-bottom: 5px;
}

.table-borderless th,
.table-borderless td {
  border: 0 !important;
}

/* **Modal 樣式調整** */
/* 讓全選/全不選的標籤文字加粗 */
.all-area-checkbox label {
  font-weight: bold !important;
}

/* ====== 門市相關 */
/* 門市清單容器，實現滾動和邊框 */
.store-checkbox-list {
  max-height: 450px !important;
  overflow-y: auto !important;
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 0.25rem;
}

/* 右側已選門市清單的卡片 */
.selected-stores-card {
  /* 如果 margin-top 沒反應，改用這個強制移動 */
  margin-top: 0px !important;

  /* 高度 = 左側下拉選單(約50px) + 左側清單(450px) */
  height: 502px !important;

  display: flex !important;
  flex-direction: column !important;
}

.selected-stores-card .card-body {
  flex: 1 !important;
  overflow-y: auto !important;
  max-height: 440px !important;
  /* 額外限制防止穿出 */
  padding: 0 !important;
}

/* 右側已選門市清單內容，實現滾動 */
.selected-stores-list {
  height: auto !important;
  /* 讓它隨 card-body 滾動即可 */
}

/* 單個已選門市項目 */
.selected-store-item {
  padding: 8px 5px !important;
  border-bottom: 1px dashed #e9ecef !important;
}

.selected-store-item:last-child {
  border-bottom: none !important;
}

.selected-store-text {
  max-height: 1.5em !important;
  /* 顯示單行 */
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.selected-store-text.expanded {
  white-space: normal !important;
  /* 展開換行 */
  max-height: none !important;
  overflow: visible !important;
}

/* ====== 商品相關 */
/* 門市清單容器，實現滾動和邊框 */
.product-checkbox-list {
  max-height: 450px !important;
  overflow-y: auto !important;
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 0.25rem;
}

/* 右側已選門市清單的卡片 */
.selected-products-card {
  /* 如果 margin-top 沒反應，改用這個強制移動 */
  margin-top: 0px !important;

  /* 高度 = 左側下拉選單(約50px) + 左側清單(450px) */
  height: 502px !important;

  display: flex !important;
  flex-direction: column !important;
}

.selected-products-card .card-body {
  flex: 1 !important;
  overflow-y: auto !important;
  max-height: 440px !important;
  /* 額外限制防止穿出 */
  padding: 0 !important;
}

/* 右側已選門市清單內容，實現滾動 */
.selected-products-list {
  height: auto !important;
  /* 讓它隨 card-body 滾動即可 */
}

/* 單個已選門市項目 */
.selected-product-item {
  padding: 8px 5px !important;
  border-bottom: 1px dashed #e9ecef !important;
}

.selected-product-item:last-child {
  border-bottom: none !important;
}

.selected-product-text {
  max-height: 1.5em !important;
  /* 顯示單行 */
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.selected-product-text.expanded {
  white-space: normal !important;
  /* 展開換行 */
  max-height: none !important;
  overflow: visible !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/marketing/survey/Add.vue